module.exports = __webpack_public_path__ + "static/media/DefianceLogo.b94c5e55.png";